import { render, staticRenderFns } from "./img-editor.vue?vue&type=template&id=13ea88b1&scoped=true"
import script from "./img-editor.vue?vue&type=script&lang=js"
export * from "./img-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea88b1",
  null
  
)

export default component.exports